import basicController from "servicestack/basic.controller.properties";

export default class OrderTocController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.preventSubmit = false;
    $ctrl.validate();
  }
  validate() {
  }
  show() {
    const $ctrl = this;
    return false;
  }
}
